export default __webpack_public_path__ + "60f96cdca90b4a4ed0c51b1c501afd8b.svg";